<p-dialog
  [(visible)]="isShowErrorDialog"
  (onHide)="closeErrorDialog()"
  [modal]="true"
  [draggable]="false"
  closeIcon="pi pi-close"
  styleClass="p-dialog-sm"
  appendTo="body"
>
  <ng-template pTemplate="header">
    <div class="p-d-flex p-dialog-title">
      <i class="pi pi-warning p-mr-2"></i
      >{{ "SigvLibrary.SystemNotification" | translate }}
    </div>
  </ng-template>
  <!-- No Group -->
  <div
    class="p-grid"
    *ngIf="errorOfValidation && errorOfValidation.length === 1"
  >
    <div class="p-col-12">
      <div
        *ngFor="let error of errorOfValidation[0]"
        class="p-d-flex p-jc-between dialog-format-error"
      >
        <label class="text">{{ error.fieldName }}</label>
        <div class="p-d-flex p-dir-col">
          <label *ngFor="let item of error.errorName" class="p-error">
            {{ item }}
          </label>
        </div>
      </div>
    </div>
  </div>
  <!-- Group -->
  <div class="p-grid" *ngIf="errorOfValidation && errorOfValidation.length > 1">
    <div class="p-col-12">
      <p-accordion
        [multiple]="true"
        expandIcon="pi pi-fw pi-collapse-open"
        collapseIcon="pi pi-fw pi-collapse-close"
      >
        <p-accordionTab
          *ngFor="let errorOfValidationGroup of errorOfValidation"
          [header]="errorOfValidationGroup[0].groupName"
          [selected]="false"
        >
          <div class="p-grid">
            <div class="p-col-12">
              <div
                *ngFor="let error of errorOfValidationGroup"
                class="p-d-flex p-jc-between dialog-format-error"
              >
                <label class="text">{{ error.fieldName }}</label>
                <div class="p-d-flex p-dir-col">
                  <label *ngFor="let item of error.errorName" class="p-error">
                    {{ item }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="p-d-flex p-jc-center">
      <button
        pButton
        type="button"
        [label]="'Common.Button.Ok' | translate"
        class="p-button-secondary p-content-button p-mr-2"
        (click)="this.isShowErrorDialog = false"
      ></button>
    </div>
  </ng-template>
</p-dialog>
